import React from 'react'
import styles from './styles.module.scss'
import { useLocation, useNavigate } from 'react-router-dom'

const SidebarItem = ({ title, icon: IconComponent, path }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const isActive = location.pathname.toLowerCase().includes(path.toLowerCase())

  const titleElements = title.split(' ').map((word, index, array) => (
    <React.Fragment key={index}>
      {word}
      {index < array.length - 1 && <br />}
    </React.Fragment>
  ))

  return (
    <div
      className={`${styles.itemRoot}  ${isActive ? styles.active : ''}`}
      onClick={() => navigate(path)}
    >
      <IconComponent size="20" color="white" />
      <div className={`text-white text-center ${styles.itemText}`}>
        {titleElements}
      </div>
    </div>
  )
}

export default SidebarItem
